// Global
import { jsx as _jsx } from "react/jsx-runtime";
import { getTestProps } from 'lib/testing/utils';
import MyClientListSearchWidget from 'widgets/MyClient';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const MyClient = (props)=>{
    const isEditing = useIsEditing();
    const id = props?.params?.RenderingIdentifier;
    const routeItemId = props?.staticProps?.routeItemId || null;
    const MyClientData = {
        params: props?.params,
        routeItemId
    };
    return /*#__PURE__*/ _jsx("div", {
        id: id,
        "data-component": "authorable/shared/search/myclient",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`component-search-result-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx(MyClientListSearchWidget, {
            rfkId: "rfkid_client_stories",
            ...MyClientData
        })
    });
};
export const Default = MyClient;
